const TARGET_SAMPLE_RATE = 48000;
const TARGET_CHANNELS = 1;
const TARGET_BIT_DEPTH = 16; // 16-bit depth to match ~256kbps at 48kHz mono

export { TARGET_SAMPLE_RATE, TARGET_CHANNELS, TARGET_BIT_DEPTH };
